<template>
  <div>
    <v-main>
      <!-- <div class="text-center">
        <img
          class="logo"
          :src="firebase_host + '/static/img/asta-live-intro3.png'"
        />
      </div> -->

      <!-- x loggati -->
      <div v-if="user_uid">
        <div class="video-background">
          <video autoplay muted loop class="video">
            <source src="/static/video/emotional-1.mp4" type="video/mp4" />
          </video>
          <div class="overlay"></div>
          <v-container class="on-video-background" fluid>
            <v-toolbar flat color="transparent" class="app-bar">
              <v-toolbar-title
                class="white--text font-weight-bold"
                @click="gotoHome"
              >
                <div class="d-flex align-center">
                  <img
                    class="logo"
                    :src="firebase_host + '/static/img/logo.png'"
                  />
                  <h3 class="font-hemi-head">ASTA LIVE</h3>
                </div>
              </v-toolbar-title>

              <v-spacer></v-spacer>

              <div v-if="!is_mobile">
                <v-btn
                  v-scroll-to="'#come-funziona'"
                  text
                  x-large
                  class="white--text font-weight-bold font-hemi-head"
                  >Come funziona
                </v-btn>
                <v-btn
                  v-scroll-to="'#prezzi'"
                  text
                  x-large
                  class="white--text font-weight-bold font-hemi-head"
                  >Prezzi
                </v-btn>
                <v-btn
                  v-scroll-to="'#leghe'"
                  text
                  x-large
                  class="white--text font-weight-bold font-hemi-head"
                  >Leghe
                </v-btn>
                <v-btn
                  @click="logout"
                  text
                  x-large
                  class="white--text font-weight-bold font-hemi-head"
                  >Logout
                </v-btn>
              </div>
              <div v-else>
                <v-btn @click="logout" icon>
                  <v-icon class="white--text">logout</v-icon>
                </v-btn>
                <v-btn icon @click="drawer = true">
                  <v-icon class="white--text">menu</v-icon>
                </v-btn>
              </div>
            </v-toolbar>
            <!-- main -->
            <v-row>
              <v-col cols="12" md="6" offset-md="3">
                <v-card
                  class="pa-4 navy darken-2 text-center mx-auto my-5"
                  min-height="250px"
                  width="450px"
                >
                  <h3 id="saluto" class="white--text">
                    Ciao<br />{{ displayName }}
                  </h3>

                  <v-btn
                    rounded
                    x-large
                    color="secondary"
                    class="py-4 px-10 white--text my-5"
                    @click="gotoCreaAsta"
                    >Crea Asta</v-btn
                  >
                  <lista-aste></lista-aste> </v-card
              ></v-col>
            </v-row>
          </v-container>
        </div>
      </div>
      <!-- x non loggati -->
      <div v-else>
        <div class="video-background">
          <video autoplay muted loop class="video">
            <source src="/static/video/emotional-1.mp4" type="video/mp4" />
          </video>
          <div class="overlay"></div>
          <v-container fluid>
            <v-toolbar flat color="transparent" class="app-bar">
              <v-toolbar-title
                class="white--text font-weight-bold"
                @click="gotoHome"
              >
                <div class="d-flex align-center">
                  <img
                    class="logo"
                    :src="firebase_host + '/static/img/logo.png'"
                  />
                  <h3 class="font-hemi-head">ASTA LIVE</h3>
                </div>
              </v-toolbar-title>

              <v-spacer></v-spacer>

              <div v-if="!is_mobile">
                <v-btn
                  v-scroll-to="'#come-funziona'"
                  text
                  x-large
                  class="white--text font-weight-bold font-hemi-head"
                  >Come funziona
                </v-btn>
                <v-btn
                  v-scroll-to="'#prezzi'"
                  text
                  x-large
                  class="white--text font-weight-bold font-hemi-head"
                  >Prezzi
                </v-btn>
                <v-btn
                  v-scroll-to="'#leghe'"
                  text
                  x-large
                  class="white--text font-weight-bold font-hemi-head"
                  >Leghe
                </v-btn>
                <v-btn
                  @click="gotoLogin"
                  text
                  x-large
                  class="white--text font-weight-bold font-hemi-head"
                  >Login
                </v-btn>
              </div>
              <div v-else>
                <v-btn @click="gotoLogin" icon>
                  <v-icon class="white--text">account_circle</v-icon>
                </v-btn>
                <v-btn icon @click="drawer = true">
                  <v-icon class="white--text">menu</v-icon>
                </v-btn>
              </div>
            </v-toolbar>
            <!-- main -->
            <v-row>
              <v-col cols="12" md="7" lg="7">
                <div class="titolo">
                  <h1
                    :style="{ fontSize: titoloFontSize + 'px' }"
                    class="font-hemi-head"
                  >
                    Aste Fantacalcio
                    <div class="typedElementWrapper">
                      <!-- <span id="typedElement"></span> -->
                      <vue-typed-js
                        :strings="typedStrings"
                        :backDelay="1000"
                        :typeSpeed="70"
                        :fadeOut="true"
                        :loop="true"
                        ><span class="typing"></span>
                      </vue-typed-js>
                    </div>
                  </h1>
                </div>
              </v-col>
              <v-col cols="12" md="4" lg="4">
                <v-card
                  class="pa-4 mx-auto my-xs-4 my-md-16 d-flex flex-column justify-space-between"
                  width="350px"
                  height="500px"
                >
                  <div
                    class="calciatore-battuto-wrapper"
                    v-if="calciatoreBattuto"
                  >
                    <calciatore-battuto
                      class="magictime"
                      :class="calciatoreBattutoAnimation"
                      :id="calciatoreBattuto"
                      xLarge
                    ></calciatore-battuto>

                    <div class="face face1 magictime" :class="faceAnimation1">
                      <div class="crediti">{{ creditiIniziali }}</div>
                    </div>

                    <div class="face face2 magictime" :class="faceAnimation2">
                      <div class="crediti">{{ creditiIniziali + 6 }}</div>
                    </div>

                    <div class="face face3 magictime" :class="faceAnimation3">
                      <div class="crediti">{{ creditiIniziali + 9 }}</div>
                    </div>

                    <div class="face face4 magictime" :class="faceAnimation4">
                      <div class="crediti">{{ creditiIniziali + 10 }}</div>
                    </div>

                    <div
                      class="assegnato magictime"
                      :class="assegnatoAnimation"
                    >
                      Assegnato!
                      <span
                        ><img src="/static/img/face-4.jpg" />
                        {{ creditiIniziali + 10 }}</span
                      >
                    </div>
                  </div>
                  <v-skeleton-loader
                    v-else
                    width="100%"
                    height="183.5"
                    type="list-item-avatar-three-line, list-item-two-line"
                  ></v-skeleton-loader>
                  <div class="handwritten font-handwritten">
                    <div>Il divertimento comincia qui</div>
                    <img src="/static/img/arrow.png" />
                  </div>
                  <div>
                    <v-btn
                      depressed
                      block
                      rounded
                      x-large
                      color="secondary"
                      class="mb-4"
                      @click="gotoCreaAsta"
                      >Crea Asta</v-btn
                    >
                    <v-btn
                      depressed
                      block
                      rounded
                      x-large
                      outlined
                      color="secondary"
                      class="mb-4"
                      @click="gotoLogin"
                      >Accedi</v-btn
                    >
                  </div>
                </v-card></v-col
              >
            </v-row>
          </v-container>
        </div>
      </div>
      <!-- 4 modalità -->
      <v-icon class="mt-4 spaceInUp magictime animation-infinite" large>
        expand_more
      </v-icon>
      <h2
        id="modalita"
        class="white--text px-4 pt-4 font-hemi-head"
        :style="{ fontSize: sottoTitoloFontSizePx }"
      >
        <span :style="{ fontSize: titoloFontSize + 'px' }">{{
          _.size(Constants.ASTA_MODE)
        }}</span>
        Modalità d'Asta
      </h2>
      <!-- 4 cards -->
      <v-container fluid>
        <v-row>
          <v-col
            cols="12"
            md="6"
            lg="3"
            v-for="asta_mode in Constants.ASTA_MODE"
            :key="asta_mode"
          >
            <v-card
              class="asta-mode ma-4 navy darken-3"
              :class="cardAnimations[asta_mode]"
              elevation="0"
              v-observe-visibility="{
                callback: (isVisible, entry) =>
                  visibilityChanged(isVisible, asta_mode),
                once: true,
                throttle: 0,
              }"
            >
              <div class="gradiented">
                <v-img
                  contain
                  :src="'/static/img/asta-mode-' + asta_mode + '.png'"
                ></v-img>
                <div class="pa-5">
                  <v-card-title class="white--text">
                    <h2 class="font-hemi-head">
                      {{ getAstaModeName(asta_mode) }}
                    </h2>
                  </v-card-title>
                  <v-card-subtitle
                    class="px-4 py-4 text-left text--text text--lighten-3"
                  >
                    <div v-html="getAstaModeShortDescr(asta_mode)"></div>
                  </v-card-subtitle>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      color="secondary"
                      rounded
                      depressed
                      outlined
                      class="pl-4"
                      @click="toggleShowMode(asta_mode)"
                    >
                      Dimmi di più
                      <v-icon right>{{
                        showMode[asta_mode] ? "expand_less" : "expand_more"
                      }}</v-icon>
                    </v-btn>
                  </v-card-actions>
                </div>
              </div>
              <v-expand-transition>
                <div v-show="showMode[asta_mode]">
                  <v-card-text>
                    <div
                      class="text-justify mb-2 text--text text--lighten-3"
                      v-html="getAstaModeLongDescr(asta_mode)"
                    ></div>
                    <v-icon color="secondary"> school </v-icon>
                  </v-card-text>
                </div>
              </v-expand-transition>
            </v-card>
          </v-col>
        </v-row>
      </v-container>

      <!-- come funziona -->
      <h2
        id="come-funziona"
        class="white--text pa-4 font-hemi-head"
        :style="{ fontSize: sottoTitoloFontSizePx }"
      >
        Come funziona
      </h2>
      <div class="pa-6">
        <come-funziona></come-funziona>
      </div>

      <!-- leghe -->
      <!-- <h2
        id="leghe"
        class="white--text pa-4 font-hemi-head"
        :style="{ fontSize: sottoTitoloFontSizePx }"
      >
        Leghe
      </h2> -->
      <div id="leghe" class="mt-16">
        <div class="video-background">
          <video autoplay muted loop class="video">
            <source src="/static/video/emotional-2.mp4" type="video/mp4" />
          </video>
          <div class="overlay"></div>

          <v-container fluid class="">
            <v-row>
              <v-col cols="12" md="7" lg="7">
                <div class="titolo">
                  <h1
                    :style="{ fontSize: titoloFontSize + 'px' }"
                    class="font-hemi-head"
                  >
                    GESTIONALE LEGHE
                  </h1>
                  <h2 class="font-hemi-head">
                    Fantapazz non è solo Asta LIVE!<br />
                    Scarica subito anche le nostre app di Gestione Leghe.<br />
                    Disponibili per Serie A, Champions League e Nazionali
                    (Mondiali e Europei)
                  </h2>
                  <div class="apps d-flex justify-center mt-2">
                    <a href="https://fantapazz.com" target="_blank"
                      ><img src="/static/img/icona-app-serie-a.png"
                    /></a>
                    <a
                      href="https://championsleague.fantapazz.com"
                      target="_blank"
                      ><img src="/static/img/icona-app-champions.png"
                    /></a>
                    <a href="https://nations.fantapazz.com" target="_blank"
                      ><img src="/static/img/icona-app-nations.png"
                    /></a>
                  </div>
                  <h2 class="font-hemi-head">
                    <v-icon class="secondary--text">celebration</v-icon> Asta
                    Live è già integrata dentro il gestionale leghe!
                  </h2>
                </div>
              </v-col>
              <v-col cols="12" md="4" lg="4">
                <div
                  class="px-5 mt-n6 mt-md-n16 mt-lg-n16 d-flex justify-center"
                >
                  <img
                    style="max-width: 400px; width: 100%"
                    src="/static/img/mockup-app-serie-a.png"
                  /></div
              ></v-col>
            </v-row>
          </v-container>
        </div>
      </div>

      <!-- Prezzi -->
      <h2
        id="prezzi"
        class="white--text pa-4 font-hemi-head"
        :style="{ fontSize: sottoTitoloFontSizePx }"
      >
        Prezzi
      </h2>
      <div class="pa-6">
        <v-card max-width="500" class="mx-auto card-prezzi">
          <div class="part-top px-6 pt-6">
            <h2 class="py-4 font-hemi-head">
              <!-- <v-icon class="secondary--text mb-4">celebration</v-icon> -->
              <!-- <vue-typed-js
              :strings="[
                'Provala subito... GRATIS!',
                'Prime ' +
                  Constants.NUM_ASSEGNAZIONI_FREE +
                  ' assegnazioni FREE',
                'Paghi solo dopo averla provata',
              ]"
              :backDelay="1000"
              :typeSpeed="30"
              :fadeOut="true"
              :loop="true"
              ><span class="typing"></span>
            </vue-typed-js> -->
              <div>Provala subito... GRATIS!</div>
              <div>
                FREE
                <span class="secondary--text text-bigger"
                  >{{ Constants.NUM_ASSEGNAZIONI_FREE }} </span
                >assegnazioni/asta
              </div>
            </h2>

            <v-btn
              rounded
              depressed
              color="secondary"
              class="py-4 px-10 white--text"
              @click="gotoCreaAsta"
              >PROVA GRATIS</v-btn
            >

            <div class="mt-4">Prova gratuitamente ASTA LIVE:</div>
            <div>
              Potrai mettere all'asta e assegnare fino a
              {{ Constants.NUM_ASSEGNAZIONI_FREE }} calciatori.
            </div>
            <div>(per ciascuna asta, in qualsiasi delle 4 modalità)</div>
            <div class="mt-4">
              Dopodichè per continuare bisogna sbloccare l'asta.
            </div>
            <div>
              Il prezzo per sbloccarla dipende dal numero massimo partecipanti
              impostato nell'asta stessa:
            </div>
            <div class="mt-4">
              <v-icon small class="white--text">info</v-icon>
            </div>
            <div class="">IMPORTANTE</div>
            <div>
              L'asta viene pagata da una sola persona e si sblocca per tutti i
              partecipanti
            </div>
          </div>
          <div class="part-bottom pa-6">
            <tabella-prezzi dark class="mt-4"></tabella-prezzi>
          </div>
        </v-card>
      </div>
    </v-main>
    <asta-footer paddedTop paddedBottom></asta-footer>
    <v-card elevation="12" class="home-drawer" v-show="drawer">
      <!-- <v-navigation-drawer
        v-model="drawer"
        permanent
        floating
        absolute
      > -->
      <!-- header -->
      <v-list-item>
        <v-spacer></v-spacer>
        <v-btn rounded icon @click="drawer = false">
          <v-icon>close</v-icon>
        </v-btn>
      </v-list-item>

      <v-list>
        <v-list-item link v-scroll-to="'#modalita'" @click="drawer = false">
          <v-list-item-icon>
            <v-icon color="text">gavel</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title class="font-weight-bold"
              >Modalità d'asta</v-list-item-title
            >
          </v-list-item-content>
        </v-list-item>

        <v-list-item
          link
          v-scroll-to="'#come-funziona'"
          @click="drawer = false"
        >
          <v-list-item-icon>
            <v-icon color="text">info</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title class="font-weight-bold"
              >Come funziona</v-list-item-title
            >
          </v-list-item-content>
        </v-list-item>

        <v-list-item link v-scroll-to="'#prezzi'" @click="drawer = false">
          <v-list-item-icon>
            <v-icon color="text">euro</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title class="font-weight-bold font-hemi-head"
              >Prezzi</v-list-item-title
            >
          </v-list-item-content>
        </v-list-item>

        <v-list-item link v-scroll-to="'#leghe'" @click="drawer = false">
          <v-list-item-icon>
            <v-icon color="text">shield</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title class="font-weight-bold font-hemi-head"
              >Gestionali Leghe</v-list-item-title
            >
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <!-- </v-navigation-drawer> -->
    </v-card>
  </div>
</template>

<script>
import db from "../../js/db";
import mixins from "../../js/mixins";
import toast from "../../js/toast";
import Config from "../../../config-app/config";
import authentication from "../../js/auth";
import ListaAste from "../common/ListaAste";
import AstaFooter from "../AstaFooter";
import CalciatoreBattuto from "../common/CalciatoreBattuto";
import TabellaPrezzi from "../common/TabellaPrezzi";
import ComeFunziona from "../common/ComeFunziona";

export default {
  name: "home-standalone",
  mixins: [mixins, toast],
  components: {
    CalciatoreBattuto,
    ListaAste,
    AstaFooter,
    ComeFunziona,
    TabellaPrezzi,
  },
  data() {
    return {
      showMode: {},
      drawer: false,
      firebase_host: Config.FIREBASE_HOST,
      displayName: authentication.getDisplayName(),
      calciatoriSorted: null,
      bestCalciatori: null,
      calciatoreBattuto: null,
      calciatoreBattutoAnimation: "",
      faceAnimation1: "d-none",
      faceAnimation2: "d-none",
      faceAnimation3: "d-none",
      faceAnimation4: "d-none",
      assegnatoAnimation: "d-none",
      creditiIniziali: "",
      cardAnimations: {},
      typedStrings: [
        "in real-time",
        "a distanza",
        "online",
        "offerte LIVE",
        "chat integrata",
      ],
    };
  },

  methods: {
    gotoCreaAsta() {
      this.$router.push({
        path: "/crea-asta",
      });
    },
    gotoLogin() {
      this.$router.push({
        path: "/login",
      });
    },
    gotoHome() {
      this.$router.push({
        path: "/",
      });
    },
    logout() {
      authentication.signOutUser();
    },
    initBestCalciatori() {
      this.bestCalciatori = this.calciatoriSorted.slice(0, 30);
    },
    deleteFromBestCalciatori(key) {
      this.bestCalciatori.splice(key, 1);
    },
    toggleShowMode(asta_mode) {
      if (this.showMode.hasOwnProperty(asta_mode)) {
        this.showMode[asta_mode] = !this.showMode[asta_mode];
      } else {
        this.showMode = {
          ...this.showMode,
          [asta_mode]: !this.showMode[asta_mode],
        };
        // this.showMode = Object.assign({}, this.showMode, {
        //   [asta_mode]: !this.showMode[asta_mode],
        // });
      }
    },

    visibilityChanged(isVisible, astaMode) {
      if (isVisible) {
        // devo fare così altrimenti cardAnimations[astaMode] nn è reactive
        // https://v2.vuejs.org/v2/guide/reactivity.html#Change-Detection-Caveats
        this.$set(this.cardAnimations, astaMode, "fadeInDownShort go animated");
      } else {
        this.$set(this.cardAnimations, astaMode, "no-visibility");
      }
    },
  },

  computed: {
    titoloFontSize() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 35;
        case "sm":
          return 50;
        case "md":
          return 65;
        case "lg":
          return 80;
        case "xl":
          return 95;
      }
    },
    sottoTitoloFontSizePx() {
      return this.titoloFontSize - 10 + "px";
    },
  },

  mounted() {
    this.$store.dispatch("setCalciatoriOriginal");
    // this.$store.dispatch("setListoneConf"); // todo per standalone
    console.log("HomeStandalone mounted.");
  },

  watch: {
    calciatori: {
      handler(val) {
        this.calciatoriSorted = _.orderBy(val, ["quotazione"], ["desc"]);
        // prendo i migliori numBest
        this.initBestCalciatori();
      },
      immediate: true,
    },
    bestCalciatori: {
      async handler(val) {
        if (_.size(val) == 0) {
          this.initBestCalciatori();
          return;
        }

        // mostro un calciatore battuto
        this.calciatoreBattutoAnimation = "spaceInDown";

        this.calciatoreBattuto = val[0].id;
        this.creditiIniziali = val[0].quotazione + 30;

        // aspetto 2 sec e mostro faces
        await this.wait(2000);
        this.faceAnimation1 = "slideRightReturn";
        await this.wait(1200);
        this.faceAnimation2 = "slideRightReturn";
        await this.wait(1200);
        this.faceAnimation3 = "slideRightReturn";
        await this.wait(1200);
        this.faceAnimation4 = "slideRightReturn";

        await this.wait(1500);
        this.assegnatoAnimation = "slideUpReturn";

        // aspetto altri 5 sec e le faccio uscire insieme
        await this.wait(5000);
        this.calciatoreBattutoAnimation = "spaceOutUp";
        this.faceAnimation1 = "spaceOutUp";
        this.faceAnimation2 = "spaceOutUp";
        this.faceAnimation3 = "spaceOutUp";
        this.faceAnimation4 = "spaceOutUp";
        this.assegnatoAnimation = "spaceOutUp";

        // aspetto 350ms (il tempo che l'exit animazione finisca)
        await this.wait(350);
        // dopodiche posso impostarne un altro (mi basta toglierlo e questo stesso watch continua)
        this.deleteFromBestCalciatori(0);
      },
      immediate: false,
    },
  },

  created() {},

  destroyed() {
    console.log("HomeStandalone destroyed.");
  },
};
</script>

<style scoped lang="scss">
.home-drawer {
  position: fixed;
  width: 256px;
  top: 15px;
  right: 15px;
}
.video-background {
  position: relative;
  .video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    max-height: 600px;
    padding-bottom: 1px; // fix strana linea sul mio chrome
  }
  .overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgb(37 44 48 / 69%);
    backdrop-filter: blur(2px);
    max-height: 600px;
  }
}

.text-bigger {
  font-size: 35px !important;
}

#saluto {
  padding: 0 30px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.container {
  position: relative;
}
.titolo {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: white;
  padding: 20px;
  height: 100%;
  .typedElementWrapper {
    background: rgb(255 255 255 / 31%);
    border-radius: 10px;
    padding: 0px 20px;
    display: block;
    // box-shadow: 0px 0px 0px 0px rgba(255, 255, 255, 0.2);
    // animation: pulsante 1.25s infinite;
  }
}
.logo {
  height: 60px;
  margin-right: 10px;
}

.calciatore-battuto-wrapper {
  position: relative;
  .assegnato {
    background: var(--v-navy-darken2);
    color: white;
    position: absolute;
    padding: 0 0 0 5px;
    top: 30px;
    right: 30px;
    font-size: 15px;
    border-radius: 5px;
    display: flex;
    align-items: center;
    span {
      display: inline-flex;
      align-items: center;
      background: rgb(0 0 0 / 80%);
      border-radius: 0 5px 5px 0;
      padding: 3px 8px;
      color: gold;
      margin-left: 5px;
      font-weight: bold;
      img {
        width: 20px;
        height: 20px;
        border-radius: 100px;
        margin-right: 3px;
      }
    }
  }
  .face {
    position: absolute;
    height: 40px;
    width: 40px;
    box-shadow: 0 5px 22px 0 rgba(0, 0, 0, 0.2);
    background-size: cover;
    border-radius: 100px;
    .crediti {
      position: absolute;
      width: 22px;
      height: 22px;
      font-size: 11px;
      display: flex;
      align-items: center;
      top: -4px;
      right: -12px;
      border-radius: 100px;
      box-shadow: 0 5px 22px 0 rgba(0, 0, 0, 0.2);
    }
  }
  .face1 {
    bottom: 16px;
    right: 40px;
    background-image: url(/static/img/face-1.jpg);
  }
  .face2 {
    bottom: 16px;
    right: 57px;
    background-image: url(/static/img/face-2.jpg);
  }
  .face3 {
    bottom: 16px;
    right: 74px;
    background-image: url(/static/img/face-3.jpg);
  }
  .face4 {
    bottom: 16px;
    right: 91px;
    background-image: url(/static/img/face-4.jpg);
  }
}
.handwritten {
  display: flex;
  align-items: center;
  div {
    font-size: 40px;
    transform: rotate(355deg);
    line-height: 33px;
  }
  img {
    height: 40px;
  }
}
.typed-element {
  justify-content: center;
}

.asta-mode {
  .gradiented {
    background-image: repeating-linear-gradient(
      8deg,
      var(--v-navy-darken3),
      var(--v-navy-darken2) 230px
    );
    border-radius: 15px;
  }
  .v-image {
    height: 200px;
  }
}
.card-prezzi {
  color: white !important;
  .part-top {
    background-image: repeating-linear-gradient(
      8deg,
      var(--v-navy-darken3),
      var(--v-navy-darken2) 275px
    );
  }
  .part-bottom {
    background-color: var(--v-navy-darken3);
  }
}

.apps {
  padding: 30px 0;

  img {
    width: 100px;
    height: 100px;
    margin: 0px 10px;
    transition: all 0.3s ease-in;
    cursor: pointer;
    &:hover {
      margin-top: -2px;
    }
  }
}
</style>
